import first from "lodash/first";
import { forwardRef } from "react";
import { graphql, useFragment } from "react-relay";

import type { sponsorTagSponsor$key } from "~/queries/__generated__/sponsorTagSponsor.graphql";

import type { StyledProps } from "./styles";
import { SponsorImage, SponsorName, SponsorTagContainer, SponsorType } from "./styles";

export type Props = {
  className?: string;
  reference: sponsorTagSponsor$key;
} & Partial<PropsFromStyledProps<StyledProps>>;

export const SponsorTag = forwardRef<HTMLSpanElement, Props>(
  (
    {
      className,
      color = "#999",
      gap = "4px",
      imageVariant,
      layoutAlignment = "start",
      layoutDirection = "vertical",
      nameFontSize = "14px",
      nameLineHeight = "16px",
      reference: reference_,
      typeFontSize = "14px",
      typeLineHeight = "14px",
      ...props
    },
    reference,
  ) => {
    const sponsor = useFragment(
      graphql`
        fragment sponsorTagSponsor on Sponsor {
          name
          type
          images {
            url
          }
        }
      `,
      reference_,
    );
    const sponsorImage = first(sponsor.images);
    return sponsor?.name ? (
      <SponsorTagContainer
        $color={color}
        $gap={gap}
        $imageVariant={imageVariant}
        $layoutAlignment={layoutAlignment}
        $layoutDirection={layoutDirection}
        $nameFontSize={nameFontSize}
        $nameLineHeight={nameLineHeight}
        $typeFontSize={typeFontSize}
        $typeLineHeight={typeLineHeight}
        className={className}
      >
        <SponsorType ref={reference} {...props}>
          {sponsor.type}
        </SponsorType>
        {sponsorImage && imageVariant ? (
          <SponsorImage
            $aspectRatio="1"
            $objectFit="cover"
            alt={sponsor.name}
            src={sponsorImage.url}
          />
        ) : (
          <SponsorName>{sponsor.name}</SponsorName>
        )}
      </SponsorTagContainer>
    ) : null;
  },
);

SponsorTag.displayName = "SponsorTag";
